import { combineReducers } from 'redux';

const masterInitialState = {
  loadStatus: 0,
  list: null,
  query: {
    keyword: '',
  },
};

const detailInitialState = {
  saveStatus: 0,
};

const editInitialState = {
  saveStatus: 0,
  input: {
    preset: false,
    name: '',
    mobile: '',
    detail: '',
    provinceId: '',
    cityId: '',
    countyId: '',
    townId: '',
  },
};

const orderDetailAddrInitailState = {
  saveStatus: 0,
  input: {
    addrId: ''
  }
}

function addressesReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_ADDRESS_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return state;
      }

      return list.reduce(
        (obj, addr) => {
          obj[addr.aid] = addr;
          return obj;
        },
        { ...state }
      );
    }

    case 'EDIT_ADDRESS_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [data.aid]: data,
      };
    }

    case 'DELETE_ADDRESS_COMPLETION': {
      const { addressId, error } = action;

      if (error) {
        return state;
      }

      let nextState = { ...state };

      nextState[addressId] = undefined;
      delete nextState[addressId];

      return nextState;
    }

    case 'CHANGE_DEF_ADDRESS_COMPLETION': {
      const { error, addressId } = action;

      if (error) {
        return state;
      }

      let nextState = {};

      for (let addrId in state) {
        nextState[addrId] = {
          ...state[addrId],
          def: addrId === addressId,
        };
      }

      return nextState;
    }

    case 'PRE_CREATE_ORDER_COMPLETION': {
      if (action.error) {
        return state;
      }

      const addr = action.data.address;

      if (!addr) {
        return state;
      }

      return {
        ...state,
        [addr.aid]: addr,
      };
    }

    case 'PRE_CREATE_HAPPYGO_ORDER_COMPLETION': {
      if (action.error) {
        return state;
      }

      const addr = action.data.order.address;

      if (!addr) {
        return state;
      }

      return {
        ...state,
        [addr.aid]: addr,
      };
    }

    case 'LOAD_REFUND_RECORD_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return state;
      }

      return list.reduce(
        (obj, refund) => {
          if (refund.address) {
            obj[refund.address.aid] = refund.address;
          }

          return obj;
        },
        { ...state }
      );
    }

    case 'LOAD_REFUND_COMPLETION': {
      if (action.error) {
        return state;
      }

      const addr = action.data.address;

      if (!addr) {
        return state;
      }

      return {
        ...state,
        [addr.aid]: addr,
      };
    }

    case 'PICK_ORDER_ADDRESS':
    case 'PICK_REFUND_ADDRESS': {
      const { address } = action;

      return {
        ...state,
        [address.aid]: address,
      };
    }

    default:
      return state;
  }
}

function masterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'FILTER_ADDRESS_LIST': {
      return {
        ...state,
        query: {
          ...state.query,
          ...action.query,
        },
      };
    }
    case 'LOAD_ADDRESS_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_ADDRESS_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: action.list.map(addr => addr.aid),
      };
    }

    case 'EDIT_ADDRESS_COMPLETION': {
      const { error, addressId, data } = action;

      if (error) {
        return state;
      }

      if (addressId) {
        return state;
      }
      if (!state.list) {
        return state;
      }

      return {
        ...state,
        list: [data.aid].concat(state.list),
      };
    }

    case 'DELETE_ADDRESS_COMPLETION': {
      const { addressId, error } = action;

      if (error) {
        return state;
      }

      let list = state.list;
      let idx = -1;

      if (list) {
        idx = list.findIndex(addrId => addrId === addressId);
      }

      if (idx === -1) {
        return state;
      }

      list = list.slice();
      list.splice(idx, 1);

      return {
        ...state,
        list,
      };
    }

    default:
      return state;
  }
}

function detailsReducer(state = {}, action) {
  switch (action.type) {
    case 'CHANGE_DEF_ADDRESS':
    case 'DELETE_ADDRESS':
    case 'EDIT_ADDRESS': {
      const { addressId } = action;

      if (!addressId) {
        return state;
      }

      return {
        ...state,
        [addressId]: {
          ...(state[addressId] || detailInitialState),
          saveStatus: 1,
        },
      };
    }

    case 'CHANGE_DEF_ADDRESS_COMPLETION':
    case 'DELETE_ADDRESS_COMPLETION':
    case 'EDIT_ADDRESS_COMPLETION': {
      const { addressId, error } = action;

      if (!addressId) {
        return state;
      }

      return {
        ...state,
        [addressId]: {
          ...(state[addressId] || detailInitialState),
          saveStatus: error ? 0 : 2,
        },
      };
    }

    default:
      return state;
  }
}

function editReducer(state = editInitialState, action) {
  switch (action.type) {
    case 'SYNC_ADDRESS_EDIT_INPUT': {
      return {
        ...state,
        input: {
          ...(action.reset ? editInitialState.input : state.input),
          ...action.input,
        },
      };
    }

    case 'EDIT_ADDRESS': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'EDIT_ADDRESS_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
      };
    }

    default:
      return state;
  }
}

function orderDetailAddrReducer(state = orderDetailAddrInitailState, action) {
  switch (action.type) {
    case 'SAVE_ORDER_DETAIL_ADDRESS': {
      return {
        ...state,
        saveStatus: 1
      }
    }
    case 'SAVE_ORDER_DETAIL_ADDRESS_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2
      }
    }
    case 'SYNC_ORDER_DETAIL_ADDRESS_INPUT': {
      const { input, reset } = action;
      return {
        ...(reset ? orderDetailAddrInitailState : state),
        input: {
          ...(reset ? orderDetailAddrInitailState.input : state.input),
          ...input
        }
      }
    }
    default:
      return state
  }
}

export default combineReducers({
  master: masterReducer,
  addresses: addressesReducer,
  details: detailsReducer,
  edit: editReducer,
  orderDetailAddr: orderDetailAddrReducer
});
